class BaseSerializer {
  deserialize(rawData) {
    if (!this.isObject(rawData)) return null;
    return { ...rawData };
  }

  serialize(modelData) {
    if (!this.isObject(modelData)) return null;
    return { ...modelData };
  }

  isObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }
}

export { BaseSerializer };
